import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

let URL = "https://benefacto-backend.developer-ourbase-camp.com/api/";

export const CummunityApi = createAsyncThunk("cummunity/detail", async () => {
	try {
		const { data } = await axios.get(`${URL}communities/get-community`);
		return data;
	} catch (err) {
		return err.message;
	}
});
